<template>
  <div class='category'>
    <category-list v-if='subcats'
                   :categories='subcats'></category-list>
    <image-gallery v-else-if='images'
                   :images='images'></image-gallery>
    <div class='epa' v-else>
      <div>
        epa! por acá todavía no hay nada.
        <br><br><a href="#" v-on:click="$router.go(-1)">volver</a>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryList from './CategoryList'
import ImageGallery from './ImageGallery'
import {categoryData} from '@/categories'

export default {
  props: ['category'],
  name: 'Category',
  components: {CategoryList, ImageGallery},
  computed: {
    subcats: function () {
      let subcats = categoryData[this.category].subcategories
      if (subcats === undefined) return undefined
      return subcats.map((cat) => this.category + cat)
    },
    images: function () {
      return categoryData[this.category].images
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Category.vue